(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-seo]').forEach((block) => {
    const content = block.querySelector('[data-collection-seo-content]');
    const toggle = block.querySelector('[data-collection-seo-toggle]');
    const moreLabel = block.querySelector('[data-collection-seo-more]');
    const lessLabel = block.querySelector('[data-collection-seo-less]');

    if (!content || !toggle) {
      return;
    }

    content.classList.add('is-collapsed');
    const clampedHeight = content.clientHeight;
    content.classList.remove('is-collapsed');
    const fullHeight = content.scrollHeight;
    content.classList.add('is-collapsed');

    if (fullHeight <= clampedHeight + 1) {
      toggle.hidden = true;
      content.classList.remove('is-collapsed');
      return;
    }

    toggle.addEventListener('click', () => {
      const isExpanded = content.classList.toggle('is-collapsed') === false;

      toggle.setAttribute('aria-expanded', String(isExpanded));
      moreLabel.hidden = isExpanded;
      lessLabel.hidden = !isExpanded;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
